module.exports = __webpack_public_path__ + "img/thaw-drivers.88031f11.jpg";